export class OrdersService {
  constructor(axios, apiUrl) {
    this.$axios = axios;
    this.apiUrl = apiUrl;
  }

  /**
   * Get an order by id - GET
   * @returns Order
   */
  async getOrderById(id, sessionId) {
    return await this.$axios.get(this.apiUrl + `Orders/Order/${id}`, {
      headers: {
        'X-SessionId': sessionId,
      }
    }).then(function (response) {
      return response.data;
    })
      .catch(function (error) {
        console.error(error);
        return undefined;
      });
  }

  /**
   * Submit a new SG Order - POST
   * @param {} data
   * @returns int
   */
  async createOrder(data, sessionId) {
    return await this.$axios.post(this.apiUrl + "Orders/Order", data, {
      headers: {
        'X-SessionId': sessionId,
      }
    }).then(function (response) {
      return response.data;
    })
      .catch(function (error) {
        console.error(error);
        return undefined;
      });
  }

  /**
   * Add new item to an existing order - POST
   * @TODO Update the params piece hers
   * @params UPDATE HERE
   * @returns @TODO PROPER RETURN HERE
   */
  async addItemToExistingOrder(id, orderItems, sessionId) {
    return await this.$axios.post(this.apiUrl + `Orders/Order/${id}/Lines/Line`, orderItems, {
      headers: {
        'X-SessionId': sessionId,
      }
    }).then(function (response) {
      return response.data;
    })
      .catch(function (error) {
        console.error(error);
        return { error: error, response: error.response.data };
      });
  }

  /**
   * update line item in an existing order - PUT
   * @TODO Update the params piece hers
   * @params UPDATE HERE
   * @returns @TODO PROPER RETURN HERE
   */
  async updateItemInExistingOrder(id, orderItems, sessionId) {
    return await this.$axios.put(this.apiUrl + `Orders/Order/${id}/Lines/Line`, orderItems, {
      headers: {
        'X-SessionId': sessionId,
      }
    }).then(function (response) {
      return response.data;
    })
      .catch(function (error) {
        console.error(error);
        return { error: error, response: error.response.data };
      });
  }

  /**
   * update order - PUT
   */
  async updateOrder(data, sessionId) {
    return await this.$axios.put(this.apiUrl + "Orders/Order", data, {
      headers: {
        'X-SessionId': sessionId,
      }
    }).then(function (response) {
      return response.data;
    })
      .catch(function (error) {
        console.error(error);
        return { error: error, response: error.response.data };
      });
  }

  /**
   * delete line item in an existing order - DELETE
   * @TODO Update the params piece hers
   * @params UPDATE HERE
   * @returns @TODO PROPER RETURN HERE
   */
  async removeItemInExistingOrder(id, lineId, sessionId) {
    return await this.$axios.delete(this.apiUrl + `Orders/Order/${id}/Lines/Line/${lineId}`, {
      headers: {
        'X-SessionId': sessionId,
      }
    }).then(function (response) {
      return response.data;
    })
      .catch(function (error) {
        console.error(error);
        return undefined;
      });
  }

  /**
   * delete all lines from an existing order
   * @TODO Update the params piece hers
   * @params UPDATE HERE
   * @returns @TODO PROPER RETURN HERE
   */
  async removeItemsInExistingOrder(id, sessionId) {
    return await this.$axios.delete(this.apiUrl + `Orders/Order/${id}/Lines`, {
      headers: {
        'X-SessionId': sessionId,
      }
    }).then(function (response) {
      return response.data;
    })
      .catch(function (error) {
        return { error: error, response: error.response.data };
      });
  }

  async addDiscount(id, data, sessionId) {
    return await this.$axios.post(this.apiUrl + `Orders/Order/${id}/Discounts/Discount`, data, {
      headers: {
        'X-SessionId': sessionId,
      }
    }).then(function (response) {
      return response.data;
    })
      .catch(function (error) {
        return { error: error, response: error.response.data };
      });
  }

  async addCoupon(id, coupon, sessionId, store) {
    return await this.$axios.post(this.apiUrl + `Orders/Order/${id}/Discounts/Coupon/${coupon}`, {}, {
      headers: {
        'X-SessionId': sessionId,
      }
    }).then(function (response) {
      store.commit('SET_ORDER_INFORMATION', response.data);
      return response.data;
    })
      .catch(function (error) {
        console.error(error);
        return undefined;
      });
  }

  async removeCoupon(id, couponId, sessionId, store) {
    return await this.$axios.delete(this.apiUrl + `Orders/Order/${id}/Discounts/Discount/${couponId}`, {
      headers: {
        'X-SessionId': sessionId,
      }
    }).then(function (response) {
      store.commit('SET_ORDER_INFORMATION', response.data);
      return response.data;
    })
      .catch(function (error) {
        console.error(error);
        return undefined;
      });
  }

  async patchOrder(id, data) {
    return await this.$axios.patch(this.apiUrl + `Orders/Order/${id}`, data).then(function (response) {
      return response.data;
    })
      .catch(function (error) {
        return { error: error, response: error.response.data };
      });
  }

  async patchOrderLine(orderId, orderLineId, data) {
    return await this.$axios.patch(`${this.apiUrl}Orders/Order/${orderId}/Lines/Line/${orderLineId}`, data);
  }

  async createPackageOrder(orderId, packageId, sessionId) {
    try {
      const response = await this.$axios.post(
        `${this.apiUrl}Orders/Order/${orderId}/Package/${packageId}`,
        {},
        {
          headers: {
            'X-SessionId': sessionId,
          },
        }
      );
      return response.data;
    } catch (error) {
      return {
        error: error.message,
        response: error.response?.data || null
      };
    }
  }

  async deletePackageOrder(orderId, packageId, sessionId, store) {
    return await this.$axios.delete(`${this.apiUrl}Orders/Order/${orderId}/Package/${packageId}`, {
      headers: {
        'X-SessionId': sessionId,
      }
    }).then(function (response) {
      store.commit('SET_ORDER_INFORMATION', response.data);
      return response.data;
    })
      .catch(function (error) {
        console.error(error);
        return undefined;
      });

  }

  /**
   * 
   * @returns Premium Package Details
   * 
   */
  async IsPremiumPackageAvailable(orderId) {
    return await this.$axios.get(`${this.apiUrl}Orders/Order/${orderId}/IsPackage`).then(function (response) {
      return response.data;
    })
      .catch(function (error) {
        return { error: error, response: error.response.data };
      });
  }

  /**
 * 
 * @returns get Package Details
 * 
 */
  async getPackageDetails(orderId, sessionId) {
    return await this.$axios.get(`${this.apiUrl}Orders/Package/Order/${orderId}`, {
      headers: {
        'X-SessionId': sessionId,
      }
    }).then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return { error: error, response: error.response.data };
    });
  }

}
